function pluralApartments(count) {
  const n = Number(count) || 0;
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} квартира`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${n} квартиры`;
  return `${n} квартир`;
}

function formatMln(price) {
  const value = Math.round((Number(price) / 1000000) * 10) / 10;
  return String(value).replace(/\.0$/, '');
}

function formatPriceLabel(min, max) {
  return `${formatMln(min)}-${formatMln(max)} млн ₽`;
}

function formatFloorLabel(min, max) {
  return min === max ? `${min} этаж` : `${min}–${max} этаж`;
}

function formatSquareLabel(min, max) {
  const fmt = (v) => {
    const n = Number(v);
    return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
  };
  return `${fmt(min)}–${fmt(max)} м²`;
}

function parseBuildings(input) {
  try {
    return JSON.parse(input.getAttribute('data-buildings') || '[]');
  } catch (e) {
    return [];
  }
}

function requestFilterCount(form) {
  if (!form || !window.$ || !window.$.request) return;
  window.$.request('onShopGetFilterCount', {
    method: 'POST',
    form,
  }).then((response) => {
    const count = response?.count ?? 0;
    const text = pluralApartments(count);
    const flatCountEl = document.getElementById('filterFlatCount');
    if (flatCountEl) flatCountEl.textContent = String(count);
    document.querySelectorAll('[data-filter-count-label]').forEach((el) => {
      el.textContent = text;
    });
  });
}

function initApartmentsFilter(root) {
  const form = (root.matches?.('form') ? root : null)
    || root.querySelector('#productsFilter')
    || root.querySelector('form');
  const fields = Array.from(root.querySelectorAll('.apartments-filter__field'));
  const defaults = {
    minFloor: root.dataset.minFloor,
    maxFloor: root.dataset.maxFloor,
    minPrice: root.dataset.minPrice,
    maxPrice: root.dataset.maxPrice,
    minSquare: root.dataset.minSquare,
    maxSquare: root.dataset.maxSquare,
    priceLabel: root.dataset.priceLabel,
  };

  function closeAll(except) {
    fields.forEach((field) => {
      if (field === except) return;
      const btn = field.querySelector('.apartments-filter__select');
      const dropdown = field.querySelector('.apartments-filter__dropdown');
      if (!btn || !dropdown) return;
      btn.setAttribute('aria-expanded', 'false');
      field.classList.remove('is-open');
      dropdown.hidden = true;
    });
  }

  function setLabel(field, text) {
    const label = field.querySelector('.apartments-filter__select-label');
    if (label) label.textContent = text;
  }

  function placeholderOf(field) {
    const label = field.querySelector('.apartments-filter__select-label');
    return label?.dataset.placeholder || '';
  }

  function notifyChange() {
    if (!form) return;
    form.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function renderBuildings(field, projectInput) {
    const slug = projectInput?.value;
    field.querySelectorAll('[data-buildings-for]').forEach((box) => {
      box.hidden = true;
      box.innerHTML = '';
    });
    if (!projectInput || !slug) return;

    const box = field.querySelector(`[data-buildings-for="${slug}"]`);
    if (!box) return;
    const buildings = parseBuildings(projectInput);
    if (!buildings.length) return;

    const currentBuilding = field.querySelector('[data-filter-building]')?.value || '';
    const chips = [{ id: '', slug: '', name: 'Все' }, ...buildings];
    box.innerHTML = chips.map((building) => {
      const checked = (building.slug || '') === currentBuilding || (!currentBuilding && !building.slug);
      return `
      <label class="apartments-filter__building-chip">
        <input type="radio" name="ui_building" value="${building.slug || ''}" data-label="${building.name}" ${checked ? 'checked' : ''}>
        <span>${building.name}</span>
      </label>`;
    }).join('');
    box.hidden = false;
  }

  function applyProject(field) {
    const selected = field.querySelector('input[name="ui_project"]:checked');
    const building = field.querySelector('input[name="ui_building"]:checked');
    const projectInput = field.querySelector('[data-filter-value]');
    const buildingInput = field.querySelector('[data-filter-building]');

    if (!selected) {
      if (projectInput) projectInput.value = '';
      if (buildingInput) buildingInput.value = '';
      setLabel(field, placeholderOf(field));
      return;
    }

    if (projectInput) projectInput.value = selected.value;
    if (buildingInput) buildingInput.value = building?.value || '';
    let label = selected.dataset.label || selected.value;
    if (building?.value) {
      label = `${label}, ${building.dataset.label || building.value}`;
    }
    setLabel(field, label);
  }

  function applyRoom(field) {
    const selected = Array.from(field.querySelectorAll('input[name="ui_room"]:checked'));
    const container = field.querySelector('[data-filter-rooms]');
    if (!container) return;

    container.innerHTML = selected.map((input) => (
      `<input type="hidden" name="room[]" value="${input.value}">`
    )).join('');

    if (!selected.length) {
      setLabel(field, placeholderOf(field));
      return;
    }

    setLabel(field, selected.map((input) => input.dataset.label || input.value).join(', '));
  }

  function rangeBounds(minInput, maxInput) {
    const absMin = Number(minInput.dataset.absMin ?? minInput.min);
    const absMax = Number(maxInput.dataset.absMax ?? maxInput.max);
    return {
      absMin: Number.isFinite(absMin) ? absMin : 0,
      absMax: Number.isFinite(absMax) ? absMax : 0,
    };
  }

  function sanitizeRangeTyping(input) {
    const allowDecimal = (input.getAttribute('inputmode') || '') === 'decimal'
      || String(input.dataset.step || '').includes('.');
    let next = String(input.value ?? '').replace(/[^\d.,]/g, '').replace(',', '.');
    if (allowDecimal) {
      const parts = next.split('.');
      next = parts.shift() + (parts.length ? `.${parts.join('').replace(/\./g, '')}` : '');
    } else {
      next = next.replace(/\./g, '');
    }
    if (input.value !== next) input.value = next;
  }

  function parseRangeDraft(minInput, maxInput, { clampPair = true } = {}) {
    const { absMin, absMax } = rangeBounds(minInput, maxInput);
    const minRaw = String(minInput.value ?? '').trim().replace(',', '.');
    const maxRaw = String(maxInput.value ?? '').trim().replace(',', '.');
    let min = minRaw === '' ? NaN : Number(minRaw);
    let max = maxRaw === '' ? NaN : Number(maxRaw);
    if (Number.isNaN(min)) min = absMin;
    if (Number.isNaN(max)) max = absMax;
    if (clampPair && min > max) [min, max] = [max, min];
    min = Math.max(absMin, Math.min(absMax, min));
    max = Math.max(absMin, Math.min(absMax, max));
    return {
      min,
      max,
      absMin,
      absMax,
      complete: minRaw !== '' && maxRaw !== '' && Number.isFinite(Number(minRaw)) && Number.isFinite(Number(maxRaw)),
    };
  }

  /** Live filter count: update hidden only, do not rewrite visible inputs while typing. */
  function syncRangeDraft(field) {
    const minInput = field.querySelector('[data-range-min]');
    const maxInput = field.querySelector('[data-range-max]');
    const hiddenMin = field.querySelector('[data-filter-min]');
    const hiddenMax = field.querySelector('[data-filter-max]');
    if (!minInput || !maxInput || !hiddenMin || !hiddenMax) return;

    const { min, max, absMin, absMax, complete } = parseRangeDraft(minInput, maxInput, { clampPair: false });
    if (!complete) return;
    const isDefault = min === absMin && max === absMax;
    hiddenMin.value = isDefault ? '' : String(min);
    hiddenMax.value = isDefault ? '' : String(max);
  }

  function applyRange(field, { force = false } = {}) {
    const minInput = field.querySelector('[data-range-min]');
    const maxInput = field.querySelector('[data-range-max]');
    const hiddenMin = field.querySelector('[data-filter-min]');
    const hiddenMax = field.querySelector('[data-filter-max]');
    const format = field.dataset.format;
    const name = field.dataset.field;
    if (!minInput || !maxInput || !hiddenMin || !hiddenMax) return;

    const active = document.activeElement;
    const editing = !force && (active === minInput || active === maxInput);
    // Пока пользователь печатает — не трогаем видимые поля (иначе jump к min/max).
    if (editing) {
      syncRangeDraft(field);
      return;
    }

    const { min, max, absMin, absMax } = parseRangeDraft(minInput, maxInput);
    minInput.value = String(min);
    maxInput.value = String(max);

    const isDefault = min === absMin && max === absMax;
    if (isDefault) {
      hiddenMin.value = '';
      hiddenMax.value = '';
      setLabel(field, name === 'price' ? defaults.priceLabel : placeholderOf(field));
      return;
    }

    hiddenMin.value = String(min);
    hiddenMax.value = String(max);

    if (format === 'price') setLabel(field, formatPriceLabel(min, max));
    else if (format === 'square') setLabel(field, formatSquareLabel(min, max));
    else setLabel(field, formatFloorLabel(min, max));
  }

  function commitField(field) {
    const type = field.dataset.field;
    if (type === 'project') applyProject(field);
    else if (type === 'room') applyRoom(field);
    else if (field.hasAttribute('data-range')) applyRange(field, { force: true });
  }

  function commitAll() {
    fields.forEach((field) => commitField(field));
    // UI-радио и пустые hidden не должны попадать в query
    root.querySelectorAll('input[name^="ui_"]').forEach((el) => {
      el.disabled = true;
    });
    form?.querySelectorAll('input[type="hidden"][name]').forEach((el) => {
      if (!el.value) el.disabled = true;
    });
  }

  function unlockUiInputs() {
    root.querySelectorAll('input[name^="ui_"]').forEach((el) => {
      el.disabled = false;
    });
    form?.querySelectorAll('input[type="hidden"][name]').forEach((el) => {
      el.disabled = false;
    });
  }

  function applyField(field) {
    commitField(field);
    closeAll();
    if (!form) {
      notifyChange();
      return;
    }
    commitAll();
    form.submit();
  }

  function resetField(field, close = true) {
    const type = field.dataset.field;
    field.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
      input.checked = false;
    });

    if (type === 'project') {
      field.querySelectorAll('[data-buildings-for]').forEach((box) => {
        box.hidden = true;
        box.innerHTML = '';
      });
      field.querySelector('[data-filter-value]').value = '';
      field.querySelector('[data-filter-building]').value = '';
      setLabel(field, placeholderOf(field));
    } else if (type === 'room') {
      const container = field.querySelector('[data-filter-rooms]');
      if (container) container.innerHTML = '';
      setLabel(field, placeholderOf(field));
    } else if (field.hasAttribute('data-range')) {
      const minInput = field.querySelector('[data-range-min]');
      const maxInput = field.querySelector('[data-range-max]');
      const map = {
        floor: ['minFloor', 'maxFloor'],
        price: ['minPrice', 'maxPrice'],
        square: ['minSquare', 'maxSquare'],
      };
      const [minKey, maxKey] = map[type] || [];
      minInput.value = defaults[minKey];
      maxInput.value = defaults[maxKey];
      field.querySelector('[data-filter-min]').value = '';
      field.querySelector('[data-filter-max]').value = '';
      setLabel(field, type === 'price' ? defaults.priceLabel : placeholderOf(field));
    }

    if (close) closeAll();
    notifyChange();
  }

  // Публичный API: перед AJAX-сабмитом всегда коммитим значения
  root.commitFilterValues = commitAll;

  fields.forEach((field) => {
    const btn = field.querySelector('.apartments-filter__select');
    const dropdown = field.querySelector('.apartments-filter__dropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = field.classList.contains('is-open');
      // перед закрытием других — сохраняем их выбор
      fields.forEach((other) => {
        if (other !== field && other.classList.contains('is-open')) {
          commitField(other);
        }
      });
      closeAll();
      if (isOpen) {
        commitField(field);
        notifyChange();
        return;
      }
      field.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
      if (form) requestFilterCount(form);
    });

    dropdown.addEventListener('click', (event) => {
      const actionBtn = event.target.closest('[data-action]');
      if (!actionBtn) return;
      event.preventDefault();
      if (actionBtn.dataset.action === 'apply-field') applyField(field);
      if (actionBtn.dataset.action === 'reset-field') resetField(field);
    });

    // Выбор сразу пишется в hidden + на кнопку
    dropdown.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      if (field.dataset.field === 'project') {
        if (input.name === 'ui_project') {
          const buildingInput = field.querySelector('[data-filter-building]');
          if (buildingInput) buildingInput.value = '';
          renderBuildings(field, input);
        }
        applyProject(field);
        notifyChange();
        return;
      }

      if (field.dataset.field === 'room' && input.name === 'ui_room') {
        applyRoom(field);
        notifyChange();
      }
    });

    if (field.hasAttribute('data-range')) {
      dropdown.querySelectorAll('[data-range-min], [data-range-max]').forEach((input) => {
        // Не вызываем notifyChange() на input: layout слушает change формы
        // и делает commitApartmentsFilter → applyRange, из‑за чего значение прыгает.
        input.addEventListener('input', () => {
          sanitizeRangeTyping(input);
          syncRangeDraft(field);
          if (form) requestFilterCount(form);
        });
        input.addEventListener('blur', () => {
          applyRange(field, { force: true });
          notifyChange();
        });
        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          applyRange(field, { force: true });
          applyField(field);
        });
      });
    }
  });

  root.querySelector('[data-filter-clear]')?.addEventListener('click', () => {
    // обычная ссылка /catalog — ничего не перехватываем
  });

  document.addEventListener('click', (event) => {
    if (root.contains(event.target)) return;
    const openFields = fields.filter((field) => field.classList.contains('is-open'));
    if (!openFields.length) return;
    openFields.forEach((field) => commitField(field));
    closeAll();
    notifyChange();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openFields = fields.filter((field) => field.classList.contains('is-open'));
    openFields.forEach((field) => commitField(field));
    closeAll();
  });

  if (form) {
    form.addEventListener('submit', () => {
      commitAll();
    });
  }

  // восстановление подписей из уже заполненных hidden
  fields.forEach((field) => {
    const type = field.dataset.field;
    if (type === 'room') {
      const values = Array.from(field.querySelectorAll('[data-filter-rooms] input[name="room[]"]'))
        .map((input) => input.value)
        .filter(Boolean);
      values.forEach((value) => {
        const checkbox = field.querySelector(`input[name="ui_room"][value="${value}"]`);
        if (checkbox) checkbox.checked = true;
      });
      applyRoom(field);
    }
    if (type === 'project') {
      const value = field.querySelector('[data-filter-value]')?.value;
      if (value) {
        const radio = field.querySelector(`input[name="ui_project"][value="${value}"]`);
        if (radio) {
          radio.checked = true;
          renderBuildings(field, radio);
        }
        applyProject(field);
      }
    }
    if (field.hasAttribute('data-range')) {
      const minVal = field.querySelector('[data-filter-min]')?.value;
      const maxVal = field.querySelector('[data-filter-max]')?.value;
      if (minVal && maxVal) {
        field.querySelector('[data-range-min]').value = minVal;
        field.querySelector('[data-range-max]').value = maxVal;
        applyRange(field);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-apartments-filter]').forEach(initApartmentsFilter);
});

// Для layout-скрипта сабмита
window.commitApartmentsFilter = function commitApartmentsFilter(form) {
  const root = form?.hasAttribute?.('data-apartments-filter')
    ? form
    : (form?.closest?.('[data-apartments-filter]') || document.querySelector('[data-apartments-filter]'));
  if (root?.commitFilterValues) root.commitFilterValues();
};
